// extracted by mini-css-extract-plugin
export default {"others-header":"Header_others-header__s3Iax","others-header__buttons":"Header_others-header__buttons__D13tk"};